import { EtapaAprovacaoStatus, FilaAprovacaoStatus, EtapaNome } from '../generated/backend-enums.js';
export { EtapaAprovacaoStatus, FilaAprovacaoStatus, EtapaNome };
export const EtapaAprovacaoStatusMap = {
    [EtapaAprovacaoStatus.PENDENTE]: 'Pendente',
    [EtapaAprovacaoStatus.AGUARDANDO]: 'Aguardando',
    [EtapaAprovacaoStatus.APROVADO]: 'Aprovado',
    [EtapaAprovacaoStatus.REPROVADO]: 'Reprovado',
    [EtapaAprovacaoStatus.ABORTADO]: 'Abortado',
    [EtapaAprovacaoStatus.CANCELADO]: 'Cancelado',
    [EtapaAprovacaoStatus.AUSENTE]: 'Ausente',
    [EtapaAprovacaoStatus.DESAPROVADO]: 'Desaprovado',
};
export const FilaAprovacaoStatusMap = {
    [FilaAprovacaoStatus.EM_ANDAMENTO]: 'Em Andamento',
    [FilaAprovacaoStatus.APROVADA]: 'Aprovada',
    [FilaAprovacaoStatus.REPROVADA]: 'Reprovada',
    [FilaAprovacaoStatus.CANCELADA]: 'Cancelada',
};
export const EtapaNomeMap = {
    [EtapaNome.CLIENTE]: 'Cliente',
    [EtapaNome.PRE_PRODUCAO]: 'Pré-Produção',
    [EtapaNome.HEAD_COMPRAS]: 'Head de Compras',
    [EtapaNome.CFO]: 'CFO',
    [EtapaNome.CTO]: 'CTO',
    [EtapaNome.CEO]: 'CEO',
    [EtapaNome.CBO]: 'CBO',
    [EtapaNome.DESAPROVADOR]: 'Revisor de Desaprovação',
    [EtapaNome.ADMINISTRADOR]: 'Intervenção administrativa',
    [EtapaNome.DIRETOR_PRODUCAO]: 'Diretor de Produção',
};
